import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { WAS } from '../../config/text/text';
import { formatCurrency } from '../../helpers/currency';
import { getMinOriginalPrice } from '../../helpers/deals';
import ThemeContext from '../../providers/ThemeProvider';

const MainDealWas = ({ deal }) => {
  const theme = useContext(ThemeContext);

  // For Multi-product deal
  const minOriginalPrice = getMinOriginalPrice(deal);

  return (
    <>
      {deal.display &&
        deal.display.discount &&
        deal.originalPrice !== deal.price && (
          <div className="deal-main-deal__was">
            <span className="deal-main-deal__was-text">{WAS}</span>{' '}
            <span className="deal-main-deal__was-number">
              {formatCurrency(
                deal.currency,
                minOriginalPrice ? minOriginalPrice : deal.originalPrice,
                false,
                true,
              )}
            </span>
          </div>
        )}

      <style jsx>{`
        .deal-main-deal__was {
          text-align: center;
          padding: 8px;
          margin-left: 16px;
          font-weight: bold;
          display: none;
          text-transform: uppercase;
        }
        .deal-main-deal__was-text {
          display: block;
          font-size: 14px;
        }
        .deal-main-deal__was-number {
          position: relative;
          display: block;
          font-size: 22px;
          line-height: 22px;
          color: ${theme.colors.primary};
        }
        .deal-main-deal__was-number:after {
          content: '';
          width: calc(100% + 10px);
          height: 1px;
          background-color: ${theme.colors.primary};
          position: absolute;
          top: 50%;
          left: -5px;
          transform: rotateZ(-10deg);
          transform-origin: 50% 50%;
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .deal-main-deal__was {
            display: block;
          }
        }
      `}</style>
    </>
  );
};

MainDealWas.propTypes = {
  deal: PropTypes.object,
};

MainDealWas.defaultProps = {
  deal: null,
};

export default MainDealWas;
